import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import goToMaterialPage from "../../common/goToMaterialPage";
import {setAdvancedQuotingSearchItem} from "../../../actions/advancedQuotingFunctions";
import {wizardAllObjectInterface} from "../../../interfaces/wizardItemInterface";

const CartItemSearchButton = (props) => {

  const {setAdvancedQuotingSearchItem, cartItem, subPart, setClickedItemActiveQuoteIndex, qtCategoryName, stepIndex,
    wizardAllObject} = props;

  const handleSearchButtonClick = async () => {
    await setClickedItemActiveQuoteIndex();
    setAdvancedQuotingSearchItem(cartItem.isEmpty ? null : cartItem);
    goToMaterialPage("shoppingcart", false, subPart, qtCategoryName, wizardAllObject, stepIndex);
  };

  const disabled = subPart.part.partId === "other_related_products" || cartItem.isMinimumCharge;

  return (
    <button className={"aq-button aq-button--search" + (disabled ? " aq-button--disabled" : "")}
            disabled={disabled} onClick={handleSearchButtonClick} />
  )
};

CartItemSearchButton.propTypes = {
  subPart: PropTypes.object.isRequired,
  cartItem: PropTypes.object.isRequired,
  setClickedItemActiveQuoteIndex: PropTypes.func.isRequired,
  qtCategoryName: PropTypes.string,
  //wizard
  wizardAllObject: PropTypes.shape(wizardAllObjectInterface),
  stepIndex: PropTypes.number,
};

const mapStateToProps = () => {
  return {
  };
};

const mapDispatchToProps = {
  setAdvancedQuotingSearchItem,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItemSearchButton)
